// extracted by mini-css-extract-plugin
module.exports = {"debug":"index-module--debug--3M9MY"};